import { render, staticRenderFns } from "./CreateCompanyForm.vue?vue&type=template&id=67538cda&"
import script from "./CreateCompanyForm.vue?vue&type=script&lang=js&"
export * from "./CreateCompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateCompanyForm.vue?vue&type=style&index=0&id=67538cda&prod&lang=css&"
import style1 from "./CreateCompanyForm.vue?vue&type=style&index=1&id=67538cda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports